import './styles/wordbox.css';
import Btn from '../subcomponents/Btn';
import { useGameStore } from '../../store/gameStore';
import { useShallow } from 'zustand/react/shallow';
import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import IconBtn from '../subcomponents/IconBtn';
import Chip from '../subcomponents/Chip';

function WordBox() {
  // Subscribe to game store
  const { foundWords, recentFoundWords } = useGameStore(
    useShallow((state) => ({
      foundWords: state.gameData[state.mode].foundWords,
      recentFoundWords: state.gameData[state.mode].recentFoundWords,
    }))
  );

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const closeDrawer = () => {
    setIsOpen(false);
  };

  const formattedFoundWords = () => {
    const sortedFoundWords = foundWords.sort();
    return sortedFoundWords.map((word) => word.replace(/^./, (char) => char.toUpperCase()));
  };

  const isRecentFoundWord = (word: string) => {
    return recentFoundWords.includes(word.toLowerCase());
  };

  return (
    <div className="word-box-wrapper">
      <Btn isWordBox text={`VIEW WORDS (${foundWords.length})`} onClick={toggleDrawer} />
      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              className="word-box-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.05 }}
              exit={{ opacity: 0 }}
              onClick={closeDrawer}
            />
            <motion.div
              initial={{ y: '100%' }}
              animate={{ y: 0 }}
              exit={{ y: '100%' }}
              transition={{ type: 'spring', stiffness: 200, damping: 25 }}
              className="word-box-container"
              style={{ pointerEvents: isOpen ? 'auto' : 'none' }}
            >
              <div className="flex justify-between items-center">
                <h2 className="word-box-title">
                  You have found <b>{foundWords.length}</b>{' '}
                  {foundWords.length === 1 ? 'word' : 'words'}
                </h2>
                <IconBtn icon="X" largeStrokeSize noBackground xl onClick={toggleDrawer} />
              </div>
              <div className="word-box-grid-wrapper">
                <div className="word-box-grid">
                  {formattedFoundWords().map((word: string, idx: number) => (
                    <Chip value={word} key={idx} isGreen={isRecentFoundWord(word)} useWrapper />
                  ))}
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}

export default WordBox;
